import React from 'react';

const addOrRemove = (props) => {
    if (props.handleRemove !== undefined ) {
        return (
            <div className="col-1">
                <div className="mt-2"><a href={null} className="gray" onClick={props.handleRemove(props.idx)}><i className="fa fa-minus"></i></a></div>
            </div>
        )
    } else if (props.handleAdd !== undefined){
        return (
            <div className="col-1">
                <div className="mt-2"><a href={null} className="gray" onClick={props.handleAdd}><i className="fa fa-plus"></i></a></div>
            </div>
        )
    }
};

export default addOrRemove;